import { defineStore } from "pinia";
import { impalaApi } from "@/main";
import JWTDecode from "jwt-decode";
import { clientObject, JWTToken } from "@/interfaces";

export const useClientStore = defineStore("clientStore", {
  state: () => ({
    clientData: undefined as clientObject | undefined,
    clientLoading: false,
    userToken: localStorage.getItem("token"),
    pageLoading: false,
  }),
  getters: {
    loggedIn: (state) => {
      if (state.userToken) {
        return JWTDecode<JWTToken>(state.userToken)?.clientId;
      } else return false;
    },
  },
  actions: {
    async loadUserData() {
      try {
        this.clientLoading = true;
        const token = this.userToken;
        if (token == null) return;
        const clientId = JWTDecode<JWTToken>(token)?.clientId;
        const { data } = await impalaApi.get(
          `/client-dashboard/client/${clientId}`
        );
        this.clientData = data;
      } catch (error) {
        console.error(error);
        return error;
      } finally {
        this.clientLoading = false;
      }
    },
    logoutUser() {
      localStorage.removeItem("token");
      this.userToken = null;
      this.clientData = undefined;
    },
  },
});
